import { plazaTopics } from '@/mocks/haijiao';

const side = [
  { board: '广场闲聊区', n: '1.2万' },
  { board: '影视瓜田', n: '9.6千' },
  { board: '数码研究所', n: '8.1千' },
  { board: '美食探店党', n: '7.2千' },
  { board: '观点交锋', n: '6.8千' },
  { board: '情感树洞', n: '5.4千' },
];

export default function Feed() {
  return (
    <section id="feed" className="border-b border-stone-200/80 bg-[#fdfaf6]">
      <div className="mx-auto max-w-[1240px] px-4 py-10 md:px-6 md:py-14">
        <div className="flex items-end justify-between gap-4">
          <div>
            <p className="flex items-center gap-2 text-sm font-semibold text-orange-600">
              <i className="ri-flag-fill"></i> 广场今日话题
            </p>
            <h2 className="mt-2 text-xl font-bold tracking-tight text-stone-900 md:text-2xl">
              正在广场刷屏的讨论，一屏扫完
            </h2>
          </div>
          <button className="hidden shrink-0 whitespace-nowrap rounded-full bg-stone-900 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-stone-800 sm:block">
            参与今日话题
          </button>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-4 lg:grid-cols-[1.6fr_1fr]">
          <div className="divide-y divide-stone-200/70 overflow-hidden rounded-2xl border border-stone-200 bg-white">
            {plazaTopics.map((t, i) => (
              <a
                key={i}
                href="#top"
                className="flex items-center gap-3 px-4 py-3.5 transition-colors hover:bg-orange-50/50 md:px-5"
              >
                <span className="text-xs text-stone-300">#{String(i + 1).padStart(2, '0')}</span>
                <div className="min-w-0 flex-1">
                  <p className="truncate text-sm font-medium text-stone-800 md:text-[15px]">
                    {t.pin && (
                      <span className="mr-1.5 inline-block rounded bg-orange-600 px-1 py-0.5 text-[10px] text-white">置顶</span>
                    )}
                    {t.title}
                  </p>
                  <p className="mt-0.5 flex items-center gap-2 text-xs text-stone-400">
                    <span className="rounded bg-orange-100 px-1.5 py-0.5 text-orange-700">{t.board}</span>
                  </p>
                </div>
                <div className="hidden shrink-0 flex-col items-end gap-1 text-right sm:flex">
                  <span className="flex items-center gap-1 text-xs font-semibold text-stone-600">
                    <i className="ri-fire-line text-orange-500"></i> {t.heat} 热度
                  </span>
                  <span className="text-xs text-stone-400">{t.replies} 条回复</span>
                </div>
              </a>
            ))}
          </div>

          <div className="flex flex-col gap-4">
            <div className="rounded-2xl border border-stone-200 bg-white p-5">
              <div className="flex items-center justify-between">
                <h3 className="text-sm font-bold text-stone-900">板块实时热度</h3>
                <i className="ri-account-circle-line text-lg text-orange-600"></i>
              </div>
              <div className="mt-4 space-y-3">
                {side.map((s, i) => (
                  <div key={s.board} className="flex items-center gap-3">
                    <span
                      className={`flex h-5 w-5 shrink-0 items-center justify-center rounded-md text-[11px] font-bold ${
                        i === 0 ? 'bg-orange-600 text-white' : 'bg-orange-100 text-orange-700'
                      }`}
                    >
                      {i + 1}
                    </span>
                    <span className="flex-1 text-sm text-stone-700">{s.board}</span>
                    <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-orange-50">
                      <div className="h-full rounded-full bg-orange-400" style={{ width: `${Math.max(30, 100 - i * 13)}%` }}></div>
                    </div>
                    <span className="w-9 shrink-0 text-right text-xs text-stone-400">{s.n}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="rounded-2xl bg-stone-900 p-5 text-white">
              <div className="flex items-center gap-2 text-sm font-semibold">
                <i className="ri-megaphone-line text-orange-400"></i> 加入讨论不迷路
              </div>
              <p className="mt-2 text-xs leading-relaxed text-stone-300">
                关注感兴趣的板块圈子，广场话题更新第一时间推送，随时参与帖子讨论。
              </p>
              <a
                href="#download"
                className="mt-3 inline-block whitespace-nowrap rounded-full bg-orange-600 px-4 py-2 text-xs font-semibold text-white transition-colors hover:bg-orange-700"
              >
                现在加入海角
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}